// src/composables/useCheckPage.js
// 頁面檢查，應對重新整理的狀況，抓取路由網址，即時做出相對應的渲染
import { watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
export default function useCheckPage () {
  const pageList = ['/accident', '/compensation', '/procedure', '/safe']
  const store = useStore()
  const route = useRoute()
  function checkPage (e) {
    console.log(e.path)
    if (!pageList.includes(e.path)) {
      store.state.nowPage = e.name.substring(0, 1) // 偵測網址，做出第二畫面的渲染
      if (store.state.nowPagetitle === '') {
        // 麵包屑連動部分，遍歷文章列表(linkpage)，取其網址比對當前路由網址
        // 當比對成功(為true)時，設定麵包屑標題(最後一層)，跳出迴圈
        for (var i = 0; i < store.state.linkpage[e.name.substring(0, 1).charCodeAt() - 65].content.length; i++) {
          if (store.state.linkpage[e.name.substring(0, 1).charCodeAt() - 65].content[i].link === e.path) {
            store.commit(
              'setPageTitle',
              store.state.linkpage[e.name.substring(0, 1).charCodeAt() - 65].content[i].text
            )
            break
          }
        }
      }
    }
  }
  // 頁面檢查，應對回到上一層網址時，vue會複用組件，導致畫面(v-if)不會初始化，回到第一畫面(卡片選擇)的狀況
  watch(
    () => route.path,
    backtoAccident => {
      if (pageList.includes(route.path)) {
        store.commit('setPage', '')
      }
    }
  )
  return {
    checkPage
  }
}
